import { IRif } from '@/models/rif-model';

// Processos que, quando TODOS marcados, caracterizam Product Line.
// Devem bater com o que o omni-pwa grava (CreateReportStepOne.tsx).
export const PRODUCT_LINE_PROCESSES = [
  'EXECUÇÃO DE MANUTENÇÃO',
  'INSPEÇÃO OBRIGATÓRIA (IIO)',
  'APROVAÇÃO PARA O RETORNO AO SERVIÇO (APRS)',
];

export const isProductLine = (rif?: IRif | null): boolean =>
  PRODUCT_LINE_PROCESSES.every((p) =>
    (rif?.maintenance_processes ?? []).includes(p)
  );
